import PropTypes from 'prop-types';
// @mui
import { Typography, Stack, Box } from '@mui/material';
// component
import Iconify from '../../components/Iconify';

// ----------------------------------------------------------------------
const COLOR_BLUE = '#008CD9';

CharityContext.propTypes = {
  charity: PropTypes.object,
};

export default function CharityContext({charity}) {
  const description  = charity.charityDetails?.description;

  return (
    <Box width={1}>
      <Typography variant="h4" mt={5}>
        About
      </Typography>
      {description?.map((desc, idx) => {
        
        return (
          <div key={idx}>           
            <Typography  mt={3} sx={{ typography: { xs: 'body2', md: 'body1' } }}>{desc}</Typography>      
          </div>
        );
      })}
      {/* {description.map((contextItem, idx) => {
        const { title, content } = contextItem;

        return (
          <div key={idx}>
            <Typography variant="h6" mt={3}>
              {title}
            </Typography>
            {content.map((contentItem) => {
              return contentItem.type === 'paragraph' ? (
                <Typography key={contentItem.value} variant="body1" mt={1} mb={2}  pr={{md:3}}>
                  {contentItem.value}
                </Typography>
              ) : (
                <div key={contentItem.value}>
                  <Typography variant="body1" mt={1} mb={1}>
                    {contentItem.listHeader}
                  </Typography>
                  <Stack spacing={1} mt={1}>
                    {contentItem.value.map((itemValue) => (
                      <Stack key={itemValue} spacing={2} direction="row" alignItems="center">
                        <div>
                          <Iconify
                            icon={'carbon:dot-mark'}
                            sx={{ color: '#000', width: { xs: 10, md: 13 }, height: { xs: 10, md: 13 } }}
                          />
                        </div>
                        <Typography sx={{ typography: { xs: 'body2', md: 'body1' } }}>{itemValue}</Typography>
                      </Stack>
                    ))}
                  </Stack>
                </div>
              );
            })}
          </div>
        );
      })} */}
    </Box>
  );
}
